/**
Code within this modules is adapted from https://github.com/module-federation/module-federation-examples/blob/master/dynamic-system-host/app1/src/App.js
MIT Licensed
*/
import React, { ComponentType, memo, ReactElement, useEffect } from 'react'
import { ErrorBoundary, LoggingOptions } from '@praxis/component-logging'
import Remote from './Remote'

export interface MicroFrontendProps {
  src: string
  module?: string
  loggingOptions?: LoggingOptions
  Loading?: ComponentType | (() => ReactElement)
  Error?: ComponentType | (() => ReactElement)
  [x: string]: any
}

const MicroFrontend = ({
  src,
  module = './App',
  loggingOptions,
  Loading,
  Error,
  ...rest
}: MicroFrontendProps) => {
  const [mfeID, mfeUrl] = src.split('@')
  const [remote, setRemote] = React.useState({
    url: '',
    scope: '',
    module: '',
  })

  useEffect(() => {
    setRemote({
      url: mfeUrl,
      scope: mfeID,
      module: module,
    })
  }, [mfeID, mfeUrl, module])

  if (!mfeID || !mfeUrl) {
    console.error('MicroFrontend requires a src prop.')
    return null
  }

  return (
    <ErrorBoundary FallbackComponent={Error} loggingOptions={loggingOptions}>
      <Remote remote={remote} Loading={Loading} Error={Error} {...rest} />
    </ErrorBoundary>
  )
}

export default memo(MicroFrontend)
